import React, { useState } from 'react';
import AInput from '../../../views/pages/manage/common/formFeilds/customInput/AInput';
import AButton from '../../../views/pages/manage/common/form-fields-mui/AButton';
import { Dialog, Tooltip } from '@mui/material';
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import InfoIconSolid from "assets/img/svg/svgComponents/InfoIconSolid";

export const EditHandler = ({ updateStatus, setOpen, open, customStyle }) => {
    const [input, setInput] = useState('')
    const closeDialog = () => {
        setOpen('')
        setInput('')
    }
    const applyHandler = () => {
        updateStatus({ ...open?.row, beneficiaryName: input, approvalAction:'APPROVE' })
        setOpen('')
        setInput('')
    }
    return (
        <Dialog
            open={!!open}
            // fullWidth
            size="md"
        >
            <div className='p-4' style={{ minWidth: '428px' }} >
                <div className='d-flex justify-content-between'>
                    <div>Edit request and approve</div>
                    <CrossIcon onClick={closeDialog} />

                </div>
                <div>
                    <AInput
                        label='Payble to'
                        value={input}
                        handler={(val) => setInput(val)}
                        placeholder='Benificiary name'
                    />

                </div>
                <div className='mt-4 d-flex justify-content-between'>
                    {/*<button >Go back</button>*/}
                    <AButton
                        className='no-ml-btn'
                        onClick={closeDialog}
                        size="md"
                        variant='general'
                    >
                        Go back
                    </AButton>

                    <AButton
                        variant='primary_filled'
                        size="sm"
                        className="no-ml-btn"
                        disabled={!input}
                        onClick={() => {
                            applyHandler()
                        }}
                    >
                        Apply changes and approve
                    </AButton>
                </div>
            </div>
        </Dialog>
    )
}

export const getStatusChipInfo = (row) => {

    const { approvalStatus, remark = "" , refundStatus} = row;


    switch (true) {

        case refundStatus == "Completed":{
            return {
                text: 'Completed',
                bgColor: "#BBE2CE",
                textColor: "#0B442D"
            }
        }
        case approvalStatus?.includes("REJECT"): {
            return {
                text: (
                    <span>
                        Rejected
                        <Tooltip title={remark || "-"}>
                            <span className='ml-2'><InfoIconSolid color={"#B32306"} /></span>
                        </Tooltip>
                    </span>
                ),
                bgColor: "#F9D9D7",
                textColor: "#B32306"
            }
        }

        case approvalStatus?.includes('PENDING'): {
            const isL1 = approvalStatus?.includes("L1");
            const isL2 = approvalStatus?.includes("L2");
            const text = `Pending at ${isL1 ? 'L1' : isL2 ?'L2': 'L3'}`;
            return {
                text: text,
                bgColor: "#FFEDC8",
                textColor: "#A17217"
            }

        }

        case approvalStatus?.includes('APPROVED'): {
            return {
                text: 'Approved',
                bgColor: "#BBE2CE",
                textColor: "#0B442D"
            }

        }

        case approvalStatus?.includes('RECHECK'): {
            return {
                text: 'Sent For Correction',
                bgColor: "#F5F5F5",
                textColor: "#262626"
            }

        }

        case approvalStatus?.includes('SUBMITTED'): {
            return {
                text: (<span>
                    Submitted
                    <Tooltip title={"Transfer Payment Pending"}>
                        <span className='ml-2'><InfoIconSolid color={"#262626"} /></span>
                    </Tooltip>
                </span>),
                bgColor: "#F5F5F5",
                textColor: "#262626"
            }
        }
        default:
            return {
                text: refundStatus,
                bgColor: "#FFEDC8",
                textColor: "#A17217"
            }   


    }

};